<template>
  <add-task-modal
    :project-id="task.project_id"
    :task="task"
    @close="$emit('close')"
    @refresh="$emit('refresh')"
    @deleted="$emit('deleted', $event)"
  />
</template>

<script>
import AddTaskModal from './AddTaskModal.vue'

export default {
  name: 'TaskDetailModal',
  components: {
    AddTaskModal
  },
  props: {
    task: {
      type: Object,
      required: true
    }
  }
}
</script>
